import Link from 'next/link';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'utils/i18n';
// containers
import QuickSearch from '../../containers/quickSearch/index';
import { SearchContext } from '../../state/search';

interface Props {
  heading: string;
  subHeading: string;
  roomType: string;
  pathname: string;
  locationPlaceholder: string;
}

const LandingPage = ({
  heading,
  subHeading,
  roomType,
  pathname,
  locationPlaceholder,
}: Props) => {
  const { t } = useTranslation('common');
  const {
    actions: { onClearRoomTypes, updateRoomTypes },
  } = useContext(SearchContext);

  useEffect(() => {
    onClearRoomTypes();
    updateRoomTypes([roomType]);
  }, [onClearRoomTypes, updateRoomTypes, roomType]);

  return (
    <>
      <div className="banner__content banner--no-bottom-margin">
        <h1 className="banner__heading">{heading}</h1>
        <h2 className="banner__intro">{subHeading}</h2>
      </div>

      <QuickSearch
        showRoomTypes={false}
        locationPlaceholder={locationPlaceholder}
      />
      {/* The old `to` prop was a react-router leftover next/link ignores. */}
      <Link href="#alternative-room-types" id="room-types-link">
        {t('shared.alternative_room_types')}
      </Link>
    </>
  );
};

export default LandingPage;
